import { AppAreaConfig } from '@/funnels/@types'
import carnivoreDietGsMale from './carnivore-diet-gs-male'
import carnivoreDietGsFemale from './carnivore-diet-gs-female'

const appAreaConfig: AppAreaConfig = {
	appArea: 'carnivore-diet-gs',
	landing: {
		ids: ['loader-carnivore-diet-gs'],
		route: {
			path: '/carnivore-diet-gs',
			name: 'carnivore-diet-gs-funnel',
		},
	},
	funnel: {
		id: 'ob-carnivore-diet-gs',
		route: {
			path: '/carnivore-diet-gs/ob/:page(.*)?',
			name: 'carnivore-diet-gs',
		},
		slug: 'carnivore-diet-gs',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			immediateRedirect: true,
			sex: {
				male: { appArea: carnivoreDietGsMale },
				female: { appArea: carnivoreDietGsFemale },
			},
		},
	},
}

export default appAreaConfig
